import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icon from '../components/AppIcon';
import Button from '../components/ui/Button';
import UpgradeModal from '../components/Upgrademodal_home'

const ADMIN_ROLES = ['admin', 'superadmin', 'owner', 'superAdmin', 'Admin', 'Owner'];

const CompanyNotActive = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);
  const [upgradeOpen, setUpgradeOpen] = useState(false);

  useEffect(() => {
    const raw = sessionStorage.getItem('inactive_company_data');
    if (!raw) return;
    try {
      const saved = JSON.parse(raw);
      const role = saved.ruolo || '';
      setIsAdmin(ADMIN_ROLES.includes(role));
    } catch {
      setIsAdmin(false);
    }
  }, []);

  const handleRenewClick = () => setUpgradeOpen(true);
  const handleUpgradeClose = () => setUpgradeOpen(false);

  return (
    <>
      <div className="min-h-screen bg-background flex items-center justify-center p-6">
        <div className="max-w-md w-full text-center space-y-8 animate-in fade-in zoom-in duration-300">

          {/* Ikona */}
          <div className="relative mx-auto w-24 h-24 bg-destructive/10 rounded-full flex items-center justify-center text-destructive">
            <Icon name="Building2" size={48} />
            <div className="absolute -top-1 -right-1 w-6 h-6 bg-background rounded-full flex items-center justify-center border-2 border-background">
              <Icon name="ShieldAlert" size={18} className="text-destructive animate-pulse" />
            </div>
          </div>

          <div className="space-y-4">
            <h1 className="text-2xl font-black uppercase tracking-tight text-foreground">
              {t('company_inactive.title')}
            </h1>
            <p className="text-muted-foreground text-sm font-medium leading-relaxed">
              {t('company_inactive.desc')}
            </p>
            <div className="pt-2">
              <button
                onClick={() => navigate('/contact')}
                className="group text-[11px] text-primary uppercase font-black tracking-[0.2em] hover:brightness-125 transition-all flex items-center justify-center w-full gap-2"
              >
                {t('company_inactive.contact_support')}
                <Icon name="ChevronRight" size={14} className="group-hover:translate-x-1 transition-transform" />
              </button>
            </div>
          </div>

          {/* DUGME — samo Admin/superAdmin/Owner */}
          {isAdmin && (
            <div className="space-y-2">
              <button
                onClick={handleRenewClick}
                className="w-full py-4 bg-primary text-white rounded-2xl font-black uppercase tracking-[0.2em] text-[11px] shadow-xl shadow-primary/25 hover:brightness-110 active:scale-95 transition-all flex items-center justify-center gap-3"
              >
                <Icon name="RotateCcw" size={16} />
                {t('company_inactive.renew_btn')}
              </button>
              <p className="text-[9px] text-muted-foreground uppercase font-black tracking-widest opacity-60">
                {t('company_inactive.renew_hint')}
              </p>
            </div>
          )}

          <div className="pt-2">
            <Button
              variant="outline"
              fullWidth
              onClick={() => navigate('/landing-authentication')}
              className="border-border hover:bg-muted font-bold uppercase text-[10px] tracking-widest"
            >
              <Icon name="ArrowLeft" size={16} className="mr-2" />
              {t('not_active_page.back_home')}
            </Button>
          </div>

          <div className="pt-4">
            <p className="text-[9px] text-muted-foreground/40 uppercase font-black tracking-[0.4em]">
              OrizonDesk Portal
            </p>
          </div>

        </div>
      </div>

      <UpgradeModal isOpen={upgradeOpen} onClose={handleUpgradeClose} />
    </>
  );
};

export default CompanyNotActive;